// Constants for the flag-gated New Season editors.

const FARMING_UNIT_EDITOR_PATH = '/farming-unit-editor';
const SEASON_EDITOR_PATH = '/season-editor';

const farmingUnitEditorUrl = (distributionId, farmingUnitId) =>
  FARMING_UNIT_EDITOR_PATH + '/' + distributionId + '/' + farmingUnitId;

const seasonEditorUrl = (distributionId, farmingUnitId) =>
  SEASON_EDITOR_PATH + '/' + distributionId + '/' + farmingUnitId;

// Same option lists as the V1 FarmingUnitModal (`countryRegionDictionary`,
// which is component-local there and so cannot be imported). Keep in sync.
const COUNTRY_REGIONS = Object.freeze({
  'USA- Arizona': ['Yuma', 'Parker', 'Wellton Mohawk', 'Safford'],
  'USA- Nebraska': ['Dawson'],
  'USA- Florida': ['Hastings'],
  'USA- California': ['Blythe'],
  Italy: ['South', 'North', 'Center'],
  India: [
    'Uttar Pradesh',
    'Punjab',
    'Haryana',
    'Maharashtra',
    'Madhya Pardesh',
  ],
  Israel: ['South', 'North', 'Center'],
  Australia: ['Queensland', 'New South Wales'],
  Mexico: ['Guanajuato'],
  Spain: ['Murcia', 'Badajoz'],
  Taiwan: ['Changhua'],
});

// Same values as V1 IrrigationSystem's `irrigationTypeMenuOptions` (module-
// private there). Keep in sync.
const IRRIGATION_TYPE_OPTIONS = Object.freeze([
  { title: 'Center-Pivot', value: 'centerPivot' },
  { title: 'Flood', value: 'flood' },
  { title: 'Furrow', value: 'furrow' },
  { title: 'N-Drip', value: 'ndrip' },
  { title: 'No Irrigation System', value: 'noIrrigationSystem' },
  { title: 'Pressurized Drip', value: 'pressurizedDrip' },
  { title: 'Sprinklers', value: 'sprinklers' },
  { title: 'Seepage', value: 'seepage' },
  { title: 'Linear', value: 'linear' },
  { title: 'Moving Laterals', value: 'moving laterals' },
]);

const DRAW_MODES = Object.freeze({
  FREE_FORM: 'free_form',
  RADIAL: 'radial',
});

const TOAST_DURATION_MS = 3000;

module.exports = {
  FARMING_UNIT_EDITOR_PATH,
  SEASON_EDITOR_PATH,
  farmingUnitEditorUrl,
  seasonEditorUrl,
  COUNTRY_REGIONS,
  IRRIGATION_TYPE_OPTIONS,
  DRAW_MODES,
  TOAST_DURATION_MS,
};
